import React, { useState } from 'react';
import { MdKeyboardArrowDown } from 'react-icons/md';
import BlockContainer from './BlockContainer';

const md = require('markdown-it')({ html: true });

function FaqCard({ number, question, answer, isLast, isOpen, handleClick }) {
  function handleBlur(e) {
    if (isOpen) {
      e.currentTarget.blur();
      handleClick(true);
    } else {
      handleClick(false);
    }
  }

  return (
    <div
      key={number}
      itemScope
      className={`w-full text-left group opacity-60 transition-opacity transition-300 active:opacity-100 focus:opacity-100 hover:opacity-100 border-b-dusk/30 border-b-2 py-4 whitespace-normal ${
        isLast ? ' !border-b-0' : ''
      }`}
      tabIndex={0}
      itemProp="mainEntity"
      itemType="https://schema.org/Question"
      onClick={(e) => handleBlur(e)}
    >
      <h3
        itemProp="name"
        className="relative text-lg m-0 leading-tight font-sonoma pr-8 cursor-pointer"
      >
        <MdKeyboardArrowDown className="absolute right-2 group-focus:rotate-180 my-1 " />
        {number}. {question}
      </h3>
      <div
        itemScope
        itemProp="acceptedAnswer"
        itemType="https://schema.org/Answer"
        className="prose prose-xs  transition-all opacity-0 group-active:opacity-100 group-focus:opacity-100 h-0 group-active:h-[fit-content] group-active:pt-3 group-focus:h-[fit-content] group-focus:pt-3 overflow-hidden text-xs"
      >
        {typeof answer === 'string' ? (
          <span
            itemProp="text"
            dangerouslySetInnerHTML={{ __html: md.render(answer) }}
          />
        ) : (
          answer
        )}
      </div>
    </div>
  );
}

export default function Faqs({
  title,
  description,
  faqs,
  bgColor,
  textColor,
  padding,
}) {
  const [openFaq, setOpenFaq] = useState(false);

  return title || description || faqs?.length > 0 ? (
    <BlockContainer
      title={title}
      description={description}
      bgColor={bgColor}
      textColor={textColor}
      padding={padding}
    >
      {faqs?.length > 0 ? (
        <div
          itemScope
          itemType="https://schema.org/FAQPage"
          className={`flex flex-wrap justify-center mx-auto w-[700px] max-w-full ${
            title || description ? ' mt-10' : ''
          }`}
        >
          {faqs.map((faq, i) => (
            <FaqCard
              key={i}
              number={i + 1}
              question={faq.question}
              answer={faq.answer}
              isLast={i === faqs.length - 1}
              isOpen={openFaq === i}
              handleClick={(current) => setOpenFaq(current ? false : i)}
            />
          ))}
        </div>
      ) : null}
    </BlockContainer>
  ) : null;
}
